import { useState, FC, useCallback } from 'react'

type ToggleProps = {
  onToggle: (args: boolean) => void
  initialState?: boolean
}
const toggleMovement = ' transform translate-x-3'

const Toggle: FC<ToggleProps> = ({ onToggle, initialState = false }) => {
  const [isToggled, setIsToggled] = useState(initialState)

  const onClick = useCallback(() => {
    setIsToggled((isToggled) => {
      onToggle(!isToggled)
      return !isToggled
    })
  }, [setIsToggled, onToggle])

  return (
    <button
      className={`w-9 h-5 flex items-center rounded-full p-1 cursor-pointer ${
        isToggled ? 'bg-primaryBlue' : 'bg-toggleGrey'
      }`}
      onClick={onClick}
    >
      <div
        className={
          'bg-white h-4 w-4 rounded-full shadow-toggle transform duration-300 ease-in-out' +
          (isToggled ? toggleMovement : '')
        }
      />
    </button>
  )
}

export default Toggle
